
import { defineComponent, onMounted, onBeforeUnmount, Ref, ref, watch } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter, useRoute } from "vue-router";
import { Modal } from "bootstrap";
import axios from "axios";
import useAlert from "@/composables/Alert";
import Title from "@/components/Title.vue"
import Button from "@/components/Button.vue"
import Api from "@/services/Api";
import Pagination from "@/components/Pagination.vue";
import useEmitter from "@/composables/Emmiter";
import ModalAdicionarMarca from "./components/ModalAdicionarMarca.vue";
import ModalEditarMarca from "./components/ModalEditarMarca.vue";
import { ElSkeleton, ElSkeletonItem } from 'element-plus'


export default defineComponent({
  name: "FiltroMarcas",
  components: {
    Title,
    Button,
    Pagination,
    ModalAdicionarMarca,
    ModalEditarMarca,
    ElSkeleton,
    ElSkeletonItem  
  },
  emits: ["alterarExibicao"],
  setup() {
    const page: Ref<number> = ref(1)
    const limit: Ref<number> = ref(10)
    const filtro: Ref<any> = ref({ nome: null, tipo: null });
      
    const auxModal: any = ref();

    const { showTimeAlert } = useAlert();

    const loading = ref(false);
    const loadSalvar: Ref<boolean> = ref(false);
    const loadExcluir: Ref<boolean> = ref(false);
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const spanWarning = ref(false);
    const spanWarningEdit = ref(false);

    const prodFinded = ref(false);

    const totalMarcas: Ref<number> = ref(0);
    const marcas: Ref<any> = ref([]);
    const marcaClicked: Ref<any> = ref([]);
    const tipoProduto = ref("");
    const nome = ref("");
    const marcaForm: Ref<any> = ref({
      nome: "",
      tipoProduto: "",
      imagem: "",
    });
    const pagination = ref<InstanceType<typeof Pagination> | null>(null);
    const skeleton: Ref<boolean> = ref(false);

    //Emitter para filtrar os itens do modal do cabeçalho
    const emitter = useEmitter();
    emitter.on("paramsFilter", (payload: any) => {
      // payload.paramsFilter vem do componente do header.
      // Se os nomes de campos forem os mesmos, faz merge direto:
      filtro.value = { ...filtro.value, ...payload.paramsFilter };

      // se for necessário mapear campos diferentes, faça aqui a transformação:
      // ex: if (payload.paramsFilter.nomeFantasia) filtro.value.produto = payload.paramsFilter.nomeFantasia

      // resetar paginação e refazer a busca
      page.value = 1;
      pagination.value?.resetPage?.(1);
      allMarcas();
    });


    function handleImgFileChange(event: Event, target: "marcaForm" | "marcaClicked" = "marcaForm") {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (!file) return;

      if (target === "marcaForm") {
        marcaForm.value.imagem = file;
        // opcional: se quiser mostrar preview no modal de criação, use lubForm.value.imagemPreview
      } else {
        // edição
        marcaClicked.value.imagem = file;
      }
    }

    //FUNCAO PARA PEGAR O TOKEN
    const getToken = async () => {
      return localStorage.getItem("token_usuario");
    };

    async function allMarcas() {
      try {
        skeleton.value = true;
        const res = await axios.get("marcaProduto", {
          params: {
            pagina: page.value,
            limite: limit.value,
            ...filtro.value
          },
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        skeleton.value = false;

        const retorno = res.data.data;
        
        marcas.value = retorno.marcas;
        totalMarcas.value = retorno.totalMarcas;
        
        
        marcas.value.length === 0 ? prodFinded.value = true : prodFinded.value = false;        

      } catch (err) {
        console.log(err);
      }
    }

    // listener para receber o evento vindo do modal
    const handleAddMarcaFromModal = async (payload: any) => {
      if (!payload || !payload.marcaForm) return;
      marcaForm.value = { ...payload.marcaForm };
      await addMarca();
    };

    if (emitter && emitter.on) {
      emitter.on("addMarca", handleAddMarcaFromModal);
    }

    // remove listener ao desmontar o componente
    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("addMarca", handleAddMarcaFromModal);
      }
    });

    async function addMarca() {
      if (emitter && emitter.emit) emitter.emit("addMarca:start");
      loading.value = true;

      try {
        // Constrói body (FormData se tiver arquivo)
        let body: any = marcaForm.value;
        const headers: any = {
          Authorization: `Bearer ${await getToken()}`,
        };

        // Se houver arquivo no marcaForm, use FormData
        if (marcaForm.value?.imagem instanceof File) {
          const formData = new FormData();

          // anexa campos simples (skip File)
          Object.entries(marcaForm.value).forEach(([key, val]) => {
            if (key === "imagem") return; // arquivo anexado depois
            if (val === undefined || val === null) {
              formData.append(key, "");
            } else if (typeof val === "object") {
              // se algum campo for objeto/array e precisa ser enviado como string
              formData.append(key, JSON.stringify(val));
            } else {
              formData.append(key, String(val));
            }
          });

          // Nome do campo do arquivo: ajuste se sua API espera 'imagem' em vez de 'imagem'
          formData.append("imagem", marcaForm.value.imagem);

          body = formData;
          // NÃO setar Content-Type — axios cuidará do boundary automaticamente
        }

        const res = await axios.post("adicionaMarcaProduto", body, {
          headers
        });

        // limpeza: remover o arquivo do form local
        marcaForm.value.imagem = "";

        if (marcas.value.length) {
          marcas.value = [];
        }

        if(res){
          await allMarcas();
          
          showTimeAlert("Marca adicionada com sucesso!");
          
          if (emitter && emitter.emit) emitter.emit("addMarca:finish", { success: true });
        }
        
      } catch (err: any) {
        if (err.response && err.response.data && err.response.data.error) {
          showTimeAlert(err.response.data.message || "Erro desconhecido", "error");
        } else {
          showTimeAlert("Não foi possivel adicionar a marca.", "error");
        }
        if (emitter && emitter.emit) emitter.emit("addMarca:finish", { success: false });
      } finally {
        loading.value = false;
      }
    }

    function verifySelectValues(e) {
      e.preventDefault();
      if (!marcaForm.value.nome || !marcaForm.value.tipoProduto ) {
        spanWarning.value = true;
        return true;
      }
      spanWarning.value = false;
      addMarca();
    }

    function clickMarca(clicked) {
      marcaClicked.value = clicked;
    }

    async function deleteMarca(clicked) {
      loadExcluir.value = true;
      try {
        const res = await axios.post("deletaMarcaProduto", clicked, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        allMarcas();
        showTimeAlert("Marca deletada com sucesso!");
        auxModal.value.hide(); // Fecha o modal após o alerta
      } catch (err) {
        showTimeAlert("Não foi possivel deletar a marca.", "error");
        auxModal.value.hide(); // Fecha o modal mesmo em caso de erro
      } finally {
        loadExcluir.value = false;
      }
    }

    async function attMarca(clicked) {
      let marcaFormatPadrao = { ...clicked };

      if (!marcaFormatPadrao.nome || !marcaFormatPadrao.tipoProduto) {
        spanWarningEdit.value = true;
        clickMarca(marcaFormatPadrao);
        return;
      }

      if (emitter && emitter.emit) emitter.emit("editMarca:start");
      loading.value = true;

      try {
        let body: any = marcaFormatPadrao;
        const headers: any = {
          Authorization: `Bearer ${await getToken()}`,
        };

        if (marcaFormatPadrao.imagem instanceof File) {
          const formData = new FormData();
          Object.entries(marcaFormatPadrao).forEach(([key, val]) => {
            if (key === "imagem") return;
            if (val === undefined || val === null) formData.append(key, "");
            else if (typeof val === "object") formData.append(key, JSON.stringify(val));
            else formData.append(key, String(val));
          });
          formData.append("imagem", marcaFormatPadrao.imagem);
          body = formData;
        }

        const res = await axios.post("atualizaMarcaProduto", body, { headers });

        if(res){
          await allMarcas();
          showTimeAlert("Marca atualizada com sucesso!");
          if (emitter && emitter.emit) emitter.emit("editMarca:finish", { success: true });
          fechaModalEditMarca();
        }
      } catch (err: any) {
        console.log(err);
        if (err.response && err.response.data && err.response.data.error) {
          showTimeAlert(err.response.data.message || "Erro desconhecido", "error");
        } else {
          showTimeAlert("Não foi possivel editar o produto.", "error");
        }
      } finally {
        loading.value = false;
      }
    }

    const openModal = id => {
      const auxElement = document.querySelector(`#${id}`);
      auxModal.value = new Modal(auxElement);
      auxModal.value.show();
    };

    function handlePageChange(pageParam) {
      page.value = pageParam;
      allMarcas();
    }


    /* MODAL ADICIONAR MARCA */
    function abrirModalAddMarca() {
      ModalAdicionarMarca.value.show()
    }

    function fechaModalAddMarca() {
      ModalAdicionarMarca.value.hide()
    }

    /* MODAL ADICIONAR MARCA*/


    /* MODAL EDITAR MARCA */
    function abrirModalEditMarca(item) {
      marcaClicked.value = item;
      // envia dados para o componente filho via emitter
      emitter.emit("openEditMarca", { marca: item });
      ModalEditarMarca.value.show();
    }

    function fechaModalEditMarca() {
      ModalEditarMarca.value.hide();
    }

    const handleEditFromModal = async (payload: any) => {
      if (!payload || !payload.marca) return;
      await attMarca(payload.marca);
    };

    if (emitter && emitter.on) {
      emitter.on("editMarca", handleEditFromModal);
    }

    /* MODAL EDITAR MARCA */

    watch(
      () => filtro.value,
      () => {
        page.value = 1;
        if (pagination.value) {
              pagination.value.resetPage(1);
            }
            allMarcas()
      }, {deep: true}
    )

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
      getToken();
      allMarcas();
      ModalAdicionarMarca.value = new Modal(document.querySelector(`#ModalAdicionarMarca`));
      ModalEditarMarca.value = new Modal(document.querySelector(`#ModalEditarMarca`));
    });
    
    return {
      spanWarning,
      spanWarningEdit,
      loading,
      totalMarcas,
      addMarca,
      abrirModalAddMarca,
      fechaModalAddMarca,
      abrirModalEditMarca,
      fechaModalEditMarca,
      tipoProduto,
      nome,
      history,
      verifySelectValues,
      marcas,
      openModal,
      clickMarca,
      marcaClicked,
      deleteMarca,
      attMarca,
      prodFinded,
      marcaForm,
      router,
      route,
      handlePageChange,
      pagination,
      skeleton,
      handleImgFileChange,
      loadSalvar,
      loadExcluir
    };
  },
});
